import { render } from "./Achats.vue?vue&type=template&id=34038040&scoped=true"
import script from "./Achats.vue?vue&type=script&lang=js"
export * from "./Achats.vue?vue&type=script&lang=js"

import "./Achats.vue?vue&type=style&index=0&id=34038040&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34038040"]])

export default __exports__